import React from 'react';
import SubmissionRow from './SubmissionRow';

const SubmissionsTable = ({ submissions, expandedId, onToggleExpand, onMarkRead, onMarkUnread, onReply, replyLoading, page, totalPages, onPageChange, onSelectAll, selectedIds, onSelectRow }) => {
  return (
    <div style={{
      background: '#0A1220',
      border: '1px solid rgba(59,111,212,0.15)',
      overflow: 'hidden'
    }}>
      {/* Table header */}
      <div style={{
        background: 'rgba(5,10,18,0.6)',
        borderBottom: '2px solid rgba(59,111,212,0.2)',
        padding: '0'
      }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr>
              <th style={{ padding: '14px 8px 14px 20px', width: '24px' }}>
                <input
                  type="checkbox"
                  onChange={e => onSelectAll(e?.target?.checked)}
                  checked={selectedIds?.length > 0 && selectedIds?.length === submissions?.length}
                  style={{ accentColor: '#E8941A', cursor: 'pointer' }}
                />
              </th>
              {['NAVN', 'KONTAKT', 'MELDING', 'SAMTYKKE', 'TIDSPUNKT', 'STATUS', '']?.map((h, i) => (
                <th key={i} style={{
                  padding: '14px 12px',
                  textAlign: 'left',
                  fontFamily: 'monospace', fontSize: '0.48rem',
                  letterSpacing: '0.25em', color: 'rgba(238,240,242,0.3)',
                  textTransform: 'uppercase', fontWeight: 400,
                  whiteSpace: 'nowrap'
                }}>{h}</th>
              ))}
            </tr>
          </thead>
        </table>
      </div>
      {/* Table body */}
      {submissions?.length === 0 ? (
        <div style={{
          padding: '64px 32px',
          textAlign: 'center'
        }}>
          <div style={{
            fontFamily: '"Arial Black", sans-serif',
            fontSize: '3rem', fontWeight: 900,
            color: 'rgba(59,111,212,0.1)',
            letterSpacing: '-0.04em', textTransform: 'uppercase',
            marginBottom: '12px'
          }}>INGEN DATA</div>
          <div style={{
            fontFamily: 'Georgia, serif', fontStyle: 'italic',
            fontSize: '0.9rem', color: 'rgba(238,240,242,0.3)'
          }}>Ingen innleveringer funnet med gjeldende filtre.</div>
        </div>
      ) : (
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <tbody>
            {submissions?.map(sub => (
              <SubmissionRow
                key={sub?.id}
                submission={sub}
                isExpanded={expandedId === sub?.id}
                onToggle={() => onToggleExpand(sub?.id)}
                onMarkRead={() => onMarkRead(sub?.id)}
                onMarkUnread={() => onMarkUnread(sub?.id)}
                onReply={onReply}
                replyLoading={replyLoading}
              />
            ))}
          </tbody>
        </table>
      )}
      {/* Pagination */}
      {totalPages > 1 && (
        <div style={{
          borderTop: '1px solid rgba(255,255,255,0.06)',
          padding: '20px 24px',
          display: 'flex', alignItems: 'center', justifyContent: 'space-between'
        }}>
          <div style={{
            fontFamily: 'monospace', fontSize: '0.55rem',
            letterSpacing: '0.15em', color: 'rgba(238,240,242,0.3)',
            textTransform: 'uppercase'
          }}>Side {page} av {totalPages}</div>
          <div style={{ display: 'flex', gap: '6px' }}>
            <button
              onClick={() => onPageChange(page - 1)}
              disabled={page <= 1}
              style={{
                background: page <= 1 ? 'rgba(255,255,255,0.03)' : 'rgba(59,111,212,0.1)',
                border: `1px solid ${page <= 1 ? 'rgba(255,255,255,0.08)' : 'rgba(59,111,212,0.3)'}`,
                color: page <= 1 ? 'rgba(238,240,242,0.2)' : '#3B6FD4',
                padding: '8px 16px',
                cursor: page <= 1 ? 'not-allowed' : 'pointer',
                fontFamily: 'monospace', fontSize: '0.6rem',
                letterSpacing: '0.1em'
              }}
            >← FORRIGE</button>
            {Array.from({ length: totalPages }, (_, i) => i + 1)?.map(p => (
              <button
                key={p}
                onClick={() => onPageChange(p)}
                style={{
                  background: p === page ? '#3B6FD4' : 'rgba(59,111,212,0.08)',
                  border: `1px solid ${p === page ? '#3B6FD4' : 'rgba(59,111,212,0.2)'}`,
                  color: p === page ? '#EEF0F2' : 'rgba(238,240,242,0.4)',
                  padding: '8px 14px',
                  cursor: 'pointer',
                  fontFamily: 'monospace', fontSize: '0.6rem',
                  fontWeight: p === page ? 700 : 400
                }}
              >{p}</button>
            ))}
            <button
              onClick={() => onPageChange(page + 1)}
              disabled={page >= totalPages}
              style={{
                background: page >= totalPages ? 'rgba(255,255,255,0.03)' : 'rgba(59,111,212,0.1)',
                border: `1px solid ${page >= totalPages ? 'rgba(255,255,255,0.08)' : 'rgba(59,111,212,0.3)'}`,
                color: page >= totalPages ? 'rgba(238,240,242,0.2)' : '#3B6FD4',
                padding: '8px 16px',
                cursor: page >= totalPages ? 'not-allowed' : 'pointer',
                fontFamily: 'monospace', fontSize: '0.6rem',
                letterSpacing: '0.1em'
              }}
            >NESTE →</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default SubmissionsTable;
